<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"\nbackground: linear-gradient(90deg, #f4978e 0%, #ffe5ec 49%, #ffe5d9 100%);\nheight:100vh;"' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container-fluid pt-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius:1.25rem;"' class="col-lg-9 mx-auto p-4  bg-white  text-center shadow" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.mixitweb.com\/storage\/icons\/UF9C3uqcunfwIWmI67SIfC4yiHflbS6ZnvTfVRsj.png","alt":"mix it web"},...{}}' :style='""' class="col-3 " ></m-img><m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row px-5 mb-5" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/panel.mixitweb.com\/crm\/projects","target":"_self"},...{}}' :style='""' class="col-lg-4 my-2" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius:15px"' class="home-card-background py-4 border shadow-sm" >
                <template #default>   <m-h4 v-bind='{...{},...{}}' :style='""' class="bi bi-chat-square-heart h2" >
                <template #default>   </template>
                </m-h4><m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>CRM   </template>
                </m-h5></template>
                </m-div></template>
                </m-a><m-a v-bind='{...{"href":"https:\/\/paneldash.mixitweb.com\/dashboard\/","target":"_self"},...{}}' :style='""' class="col-lg-4 my-2" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius:15px"' class="home-card-background py-4 border shadow-sm" >
                <template #default>   <m-h4 v-bind='{...{},...{}}' :style='""' class="bi bi-person-badge h2" >
                <template #default>   </template>
                </m-h4><m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>داشبورد   </template>
                </m-h5></template>
                </m-div></template>
                </m-a><m-a v-bind='{...{"href":"https:\/\/paneldash.mixitweb.com\/user-subscription","target":"_self"},...{}}' :style='""' class="col-lg-4 my-2" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius:15px"' class="home-card-background py-4 border shadow-sm" >
                <template #default>   <m-h4 v-bind='{...{},...{}}' :style='""' class="bi bi-receipt-cutoff h2" >
                <template #default>   </template>
                </m-h4><m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>صورت حساب ها   </template>
                </m-h5></template>
                </m-div></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="my-5 text-center" >
                <template #default>   <m-a v-bind='{...{"href":"tel:09365249788","target":"_self"},...{}}' :style='""' class="" >
                <template #default>09365249788   </template>
                </m-a><m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>خیابان شریعتی جنب بانک تجارت   </template>
                </m-h5></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="row justify-content-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/trustseal.enamad.ir\/?id=303010&Code=0vFfnz4HJyu7z97FhqXM","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.ronachoob.com\/storage\/assets\/enamad_icon_text_color_blue_1024.png","alt":"ronachoob enamad"},...{}}' :style='"height:140px"' class="img-fluid" ></m-img></template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"Home\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="d-inline-block" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/panelapi.mixitweb.com\/storage\/assets\/ZarinPal.png","alt":"ronachoob enamad"},...{}}' :style='"height:140px"' class="img-fluid" ></m-img></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mImg,mA,mH4,mH5 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
